// Bespoke client for the RBAC roles API (/api/roles). Hand-written (not generated) so it lives
// beside its consumer : `src/API/` is wiped by `npm run swagger`. Goes through the shared axios
// instance so the Auth0AxiosBridge attaches the admin token.
import axios from "axios";

const apiBase = (process.env.REACT_APP_API_URL ?? "").replace(/\/+$/, "");

export interface Role {
	key: string;
	name: string;
	description?: string | null;
	permissions: string[];
	isSystem: boolean;
	userCount: number;
	createdAt: string;
	updatedAt: string;
}

export interface RoleInput {
	name: string;
	description?: string | null;
	permissions: string[];
}

/** Une fuite d'escalade détectée par l'analyse de cohérence serveur (RbacLeakAnalyzer). */
export interface RbacLeak {
	roleKey: string;
	/** Vecteur : "roles:write" (réécriture de définition) ou "users:write" (échange entre détenteurs). */
	via: string;
	reachableRoleKey?: string | null;
	excessTokens: string[];
	severity: "error" | "warning";
	/** Explication FR exacte, affichée telle quelle dans la bannière. */
	explanation: string;
}

/** Réponse des POST/PUT de rôle : le rôle sauvegardé + l'analyse complète des fuites
 *  (la sauvegarde n'est jamais bloquée : la bannière se rafraîchit avec ces leaks). */
export interface RoleSaveResult {
	role: Role;
	leaks: RbacLeak[];
}

export const rolesClient = {
	async list(): Promise<Role[]> {
		const r = await axios.get<Role[]>(`${apiBase}/api/roles`, { withCredentials: true });
		return r.data ?? [];
	},
	async leaks(): Promise<RbacLeak[]> {
		const r = await axios.get<{ leaks: RbacLeak[] }>(`${apiBase}/api/roles/leaks`, { withCredentials: true });
		return r.data?.leaks ?? [];
	},
	async create(key: string, body: RoleInput): Promise<RoleSaveResult> {
		const r = await axios.post<RoleSaveResult>(`${apiBase}/api/roles/${encodeURIComponent(key)}`, body, { withCredentials: true });
		return r.data;
	},
	async update(key: string, body: RoleInput): Promise<RoleSaveResult> {
		const r = await axios.put<RoleSaveResult>(`${apiBase}/api/roles/${encodeURIComponent(key)}`, body, { withCredentials: true });
		return r.data;
	},
	async remove(key: string): Promise<void> {
		await axios.delete(`${apiBase}/api/roles/${encodeURIComponent(key)}`, { withCredentials: true });
	}
};
